export default __webpack_public_path__ + "static/media/arrow-right-up-grn.e28b4a9f30a110885006e913b961f77c.svg";